import { TNetworkResponseSimplified } from './INetworkLoader';

// eslint-disable-next-line @typescript-eslint/typedef
export const NetworkLoaderEvent = {
  events: {
    browserRedirectDetected: 'networkLoader.events.browserRedirectDetected',
    networkRequestSettled: 'networkLoader.events.networkRequestSettled',
  },
  stats: {
    statsReady: 'networkLoader.stats.statsEvent',
  },
} as const;

export type TNetworkLoaderEvents = {
  [NetworkLoaderEvent.events.browserRedirectDetected]: {
    requestUrl: string;
    responseUrl: string;
  };
  [NetworkLoaderEvent.events.networkRequestSettled]: {
    response: TNetworkResponseSimplified;
  };
};
